import React from 'react';
import { SearchX, MessageSquareWarning, TicketX, EyeOff } from 'lucide-react';

const PAINS = [
  {
    testId: 'landing-pain-search',
    icon: SearchX,
    span: 'md:col-span-2',
    title: 'Búsquedas fallidas = Ventas perdidas',
    text: 'Mi buscador no encuentra nada si el cliente escribe mal o busca por sinónimos. El cliente se frustra y se va a la competencia.',
  },
  {
    testId: 'landing-pain-support',
    icon: MessageSquareWarning,
    span: 'md:col-span-2',
    title: 'Soporte inmanejable',
    text: 'Contesto WhatsApp, email y mensajes de pedido por separado, no doy la vida. El equipo está agotado de repetir lo mismo.',
  },
  {
    testId: 'landing-pain-popups',
    icon: TicketX,
    span: 'md:col-span-2',
    title: 'Popups que molestan, no convierten',
    text: 'Mis popups de descuento son genéricos, interrumpen la navegación y no logran captar leads de calidad.',
  },
  {
    testId: 'landing-pain-blindness',
    icon: EyeOff,
    span: 'md:col-span-2',
    title: 'Ceguera de datos',
    text: 'No sé qué buscan mis clientes que no encuentran. Estoy perdiendo oportunidades de vender productos altamente demandados.',
  },
];

export function ProblemAgitation() {
  return (
    <section id="problema" data-testid="landing-problem-section" className="py-24 md:py-32 px-6 max-w-7xl mx-auto">
      <div className="mb-14 max-w-2xl">
        <h2 className="text-3xl md:text-4xl font-black tracking-tighter text-white">
          Sabemos lo frustrante que es gestionar una tienda hoy...
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
        {PAINS.map((p) => (
          <div
            key={p.testId}
            data-testid={p.testId}
            className={`${p.span} rounded-2xl border border-white/10 border-l-2 border-l-amber-500/50 bg-[#0F0F11] p-7`}
          >
            <p.icon size={22} className="text-amber-400/80 mb-4" />
            <h3 className="text-white font-bold text-lg mb-2">{p.title}</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">{p.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
